<script>
	import { onMount } from 'svelte';
	import { film, jwt } from './store.js';
	import { navigate, useFocus } from 'svelte-navigator';
  
	let focusRef;
	useFocus(focusRef);

	let datas = [];
	let name = '';

	let isLoading = false;

	$: loadingView = isLoading ? 'block' : 'none';
  
	const getMovies = async () => {
		if (name === '') {
			return;
		}
		isLoading = true;
		datas = [];
		const response = await fetch('https://api.abittel.fr/movie/find/' + name, {
			headers: {
				'Authorization': 'Bearer ' + $jwt
			}
		});

		if (response.status === 401) {
			localStorage.removeItem('token');
			$jwt = '';
			navigate('/login');
			return;
		}

		datas = await response.json();
		isLoading = false;
	};

	onMount(async () => {
		focusRef.focus();
	});

  </script>
  
<div bind:this={focusRef}>
	<div class="title">
		<input type="text" placeholder="Search for a movie" on:keydown={(key) => {
			if (key.key === 'Enter') {
				getMovies();
			}
		}} bind:value={name} />
		<button on:click={getMovies}>Search</button>
	</div>

	<div class="films">
		{#if datas.length !== 0}
			{#each datas as data}
				{#if data.title && data.image}
					<div class="oneMovie">
						<img src="data:image/jpg;base64,{data.image}" alt={data.title} on:click={() => {
							$film = data
							navigate('/links')
						}} title={data.title}/>
						<p>{data.title}</p>
					</div>
				{/if}
			{/each}
		{:else if datas.length === 0 && isLoading === false}
			<p class="notFound">No movies found</p>
		{/if}
	</div>

	<div id="loader" style="display: {loadingView}"></div>
</div>

<style>
	.films {
		display: grid;
		justify-items: center;
		align-items: center;
		grid-template-columns: repeat(auto-fill, minmax(200px, 20fr));
	}
  
	img {
		width: 10rem;
		height: auto;
		cursor: pointer;
	}
	 
	.title {
		display: flex;
		align-items: center;
		justify-content: center;
		@media (max-width: 768px) {
			position: sticky;
			margin-top: 3rem;
			margin-bottom: 1rem;
		}
	}

	.title button {
		margin-left: 1rem;
		cursor: pointer;
	}

	.notFound {
		position: absolute;
		margin-top: 10rem;
		font-size: 2rem;
		/* bold */
		font-weight: 700;
	}

	.oneMovie {
		margin-right: 2rem;
		margin-bottom: 2rem;
		text-align: center;
	}
	input[type="text"] {
		padding: 10px;
		border-radius: 5px;
		border: 3px solid #ccc;
		box-sizing: border-box;
		transition: border-color 0.3s ease;
	}

	input[type="text"]:focus {
		border-color: #40466d;
		outline: none;
	}
	button {
		/* margin: 0.5rem; */
		padding: 0.5rem 1rem;
		cursor: pointer;
		text-decoration: none;
        border-radius: 5px;
        transition: background-color 0.3s ease;
        background-color: #40466d;

		border: none;

		color: #ffffff;
	}

	button:hover {
		background-color: #354190;
	}

	#loader {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 48px;
		height: 48px;
		border: 5px solid #000000;
		border-bottom-color: #908b8a9a;
		border-radius: 50%;
		display: inline-block;
		box-sizing: border-box;
		animation: rotation 1s linear infinite;

		@media (max-width: 768px) {
			left: 45%;
		}
	}

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

</style>